<template>
  <div class="skel-row">
    <SkeletonBlock
      v-for="(w, idx) in widths"
      :key="idx"
      :width="w"
      height="12px"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from 'vue'
import SkeletonBlock from './SkeletonBlock.vue'

export default defineComponent({
  name: 'SkeletonRow',
  components: { SkeletonBlock },
  props: {
    // Larguras relativas de cada "coluna" da linha (ex.: [30, 50, 15])
    columns: { type: Array as PropType<number[]>, default: () => [25, 45, 15] }
  },
  setup(props) {
    const widths = computed(() => props.columns.map(c => `${c}%`))
    return { widths }
  }
})
</script>

<style scoped lang="scss">
.skel-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(31, 30, 26, 0.08);

  .skel-block {
    flex-shrink: 0;
  }
}
</style>
